import React from 'react';
import LocationTemplate from './LocationTemplate';

const RoseboroPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Roseboro"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28382"]}
      latitude={34.9548}
      longitude={-78.5129}
      population={1191}
      historicalFact="Incorporated in 1891, named for early settler John Rose."
      nearbyTowns={[
        "Clinton, NC",
        "Garland, NC",
        "Salemburg, NC",
        "Turkey, NC",
        "Newton Grove, NC",
        "Dunn, NC",
        "Autryville, NC",
        "Godwin, NC"
      ]}
    />
  );
};

export default RoseboroPage;